import "@theme/front/init.scss";

import "bootstrap-front/js/dist/tooltip";
import "bootstrap-front/js/dist/collapse";
import "bootstrap-front/js/dist/dropdown";
import "bootstrap-front/js/dist/modal";
import "bootstrap-front/js/dist/tab";

import "nette.ajax.js";

import "@mdi/font/css/materialdesignicons.min.css";

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel";

import "lightbox2/dist/css/lightbox.css";
import lightbox from "lightbox2/dist/js/lightbox";

import AutoComplete from "autocomplete-js";
import "autocomplete-js/dist/autocomplete.css";

import "@/front/alert";
import "@/front/addToCart";
import "@/front/cart";
import "@/front/cookie";

import Nette from "@/front/netteForms";
Nette.initOnLoad();
window.Nette = Nette;

import "@/front/plugins/twigrid.datagrid";

document.addEventListener("DOMContentLoaded", () => {
	$.nette.init();

	$("[data-toggle='tooltip']").tooltip({
		container: "body",
		delay: {show: 500, hide: 100}
	});

	if (window.innerWidth < 768) {
		$("#category-subcategories-collapse").removeClass("show");
		$("#category-filters-collapse").removeClass("show");
	}

	const fileInputs = document.querySelectorAll('.custom-file-input');

	fileInputs.forEach(function (input) {
		input.addEventListener('change', function (e) {
			const fileName = e.target.files.length > 0 ? e.target.files[0].name : 'Soubor nevybrán';
			const label = e.target.nextElementSibling;

			if (label && label.classList.contains('custom-file-label')) {
				label.textContent = fileName;
			}

			const wrapper = e.target.closest('.custom-file');
			if (wrapper) {
				const feedback = wrapper.querySelector('.invalid-feedback');
				if (feedback) {
					feedback.remove();
				}
			}

			e.target.classList.remove('is-invalid');
		});
	});

	if (window.app.searchUrl && window.app.productPageUrl) {
		AutoComplete({
			Url: window.app.searchUrl,
			MinChars: 3,
			QueryArg: "product-search",
			_Render: function (response) {
				if (this.DOMResults.hasChildNodes()) {
					this.DOMResults.removeChild(this.DOMResults.childNodes[0]);
				}
				var ul = document.createElement("div");

				if (response === "") {
					var div = document.createElement("div");
					div.classList.add("bg-danger", "text-white", "dropdown-item", "text-center", "p-3");
					div.innerHTML = "Nic jsme bohužel nenašli, zkuste jiný výraz.";

					ul.appendChild(div);
				} else {
					const items = JSON.parse(response);

					for (var key in items) {
						if (!items.hasOwnProperty(key)) continue;

						var a = document.createElement("a");
						var item = items[key];

						a.classList.add("dropdown-item");
						a.href = window.app.productPageUrl + "/" + item.slug;
						a.title = item.name;

						if (item.image) {
							a.innerHTML = "<img src='/upload/product/" + item.id + "/" + item.image + "' />" + item.name;
						} else {
							a.innerHTML = item.name;
						}

						ul.appendChild(a);
					}

					a = document.createElement("a");

					a.classList.add("dropdown-item", "bg-secondary", "text-white", "px-3", "py-2", "form-search-toggle", "cursor-pointer");
					a.innerHTML = "<i class='mdi mdi-magnify mdi-scale-1-3'></i>&nbsp;&nbsp;Zobrazit všechny výsledky vyhledávání";

					ul.appendChild(a);
				}

				this.DOMResults.appendChild(ul);

				$(".form-search-toggle").off("click").on("click", function () {
					$(this).closest("form").submit();
				});
			},
			_Blur: function () {
				setTimeout(function () {
					this.DOMResults.setAttribute("class", "autocomplete");
				}.bind(this), 150);
			}
		}, ".form-search-autocomplete");
	}

	lightbox.option({
		wrapAround: true,
		showImageNumberLabel: false
	});

	$(".manufacturer-carousel").owlCarousel({
		items: 6,
		margin: 16,
		loop: true,
		autoplay: true,
		autoplayTimeout: 4000,
		autoplaySpeed: 1000,
		autoplayHoverPause: true,
		dots: false,
		nav: true,
		navText : [
			"<img alt='Šipka - Doleva' src='" + window.app.baseUri + "/dist/img/icons/chevron-left.svg' height='15' />",
			"<img alt='Šipka - Doprava' src='" + window.app.baseUri + "/dist/img/icons/chevron-right.svg' height='15' />",
		],
		responsive : {
			0: {
				margin: 16,
				items: 2
			},
			768: {
				margin: 16,
				items: 3
			},
			992: {
				margin: 16,
				items: 4
			},
			1200: {
				margin: 16,
				items: 6
			}
		}
	});

	$(".slides-carousel").owlCarousel({
		items: 1,
		margin: 16,
		loop: true,
		autoplay: true,
		autoplayTimeout: 5000,
		autoplaySpeed: 2000,
		autoplayHoverPause: true,
		dots: true,
		responsive : {
			0: {
				items: 1
			},
			768: {
				items: 1
			},
			992: {
				items: 1
			},
			1200: {
				items: 1
			}
		}
	});

	$(".buttons-container").off("click").on("click", function () {
		window.location.href = $(this).find(".btn-show-detail").attr("href");
	});

	$(".btn-product-edit").off("click").on("click", function (e) {
		e.stopPropagation();
	});

	$.nette.ext("buttons-container", {
		success: function () {
			$(".buttons-container").off("click").on("click", function () {
				window.location.href = $(this).find(".btn-show-detail").attr("href");
			});

			$(".btn-product-edit").off("click").on("click", function (e) {
				e.stopPropagation();
			});
		}
	});

	$.nette.ext("history", {
		success: function (e) {
			history.replaceState(null, "", e.history);
		}
	});
});
